<template>
  <div>
    <!-- 暂无字段 -->
    <el-table
      :data="dt2table1"
      class="tb-edit"
      style="width: 100%"
      border
      ref="multipleTable"
      :header-cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column label="厂商" prop="cpasturename"> </el-table-column>
      <el-table-column label="是否提报完成" width="120" prop="cbid">
      </el-table-column>
      <el-table-column label="提报日期" width="180" prop="cinvname_price">
      </el-table-column>
      <el-table-column label="报价文件查看" width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="opentable(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="付款条件查看" width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="opentable(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title=""
      :visible.sync="dialogFormVisible"
      customClass="way sadform"
      :append-to-body="true"
    >
      <el-table
        :data="digedtable"
        v-if="dialogFormVisible"
        class="tb-edit"
        ref="sitesTable"
        style="width: 100%"
        row-key="op_inquiry_price_autoid"
        border
      >
        <el-table-column
          type="selection"
          width="45"
          align="center"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column prop="cvenname_price" label="供应商">
        </el-table-column>
        <el-table-column prop="iyf_price" label="文件" width="60">
        </el-table-column>
        <el-table-column prop="iqjnumber" label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain>查看</el-button>
            <el-button size="mini" type="primary" plain>下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- </el-form> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">关闭</el-button>
        <el-button type="success" @click="shoubiaoconfirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dt2table1: { type: Array },
    urlid: { type: String },
  },
  name: "ruleTable",
  data () {
    return {
      multiple: [],
      dialogFormVisible: false,

      sdarules: {
        cusername: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      state: "-1",
      digedtable: [],
      sdatable: {},
    };
  },
  created () {
    setTimeout(() => {
      console.log(this.dt2table1, "dt2table1");
    }, 2200);
  },
  mounted () { },
  methods: {
    //分段授标关闭
    closesad () {
      this.dialogFormVisible = false;
    },
    opentable () {
      this.dialogFormVisible = true;
    },
  },
};
</script>
